import styled from "styled-components";

import { ProfileSupportStyledProps as Props } from "./ProfileSupport.types";
import CONSTANTS from "config/constants";

const { BREAKPOINTS } = CONSTANTS;
const { desktop, tablet, mobile } = BREAKPOINTS;

const ProfileSupportStyled = styled.div<Props>`
  min-width: var(--sizes-page-minWidth);
  max-width: var(--sizes-page-maxWidth);
  min-height: var(--sizes-page-minHeight);
  padding-top: ${props =>
    !props.withBottomResponsiveButtons
      ? "var(--sizes-navbar-height-mobile-without-bottom-buttons)"
      : props.withBottomSearch
      ? "var(--sizes-navbar-height-mobile)"
      : "var(--sizes-navbar-height-mobile-without-search)"};
  background-color: var(--palette-gray-s0-l97);
  display: grid;
  grid-template-columns: var(--sizes-page-columns);
  grid-template-rows: 1fr;
  grid-template-areas:
    ".      main   ."
    "footer footer footer";

  @media (min-width: ${desktop}px) {
    padding-top: var(--sizes-navbar-height);
  }

  .ProfileSupport {
    &__header {
    }

    &__labels {
      line-height: 2.4rem;
      padding: 1.2rem 0;
      cursor: pointer;
      font-size: 1.6rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 0.1rem solid var(--palette-gray-s0-l95);

      &:last-of-type {
        border-bottom: 0;
      }
    }

    &__main {
      grid-area: main;
      margin-bottom: 3.2rem;
      padding-top: 8.8rem;

      @media screen and (min-width: ${desktop}px) {
        display: grid;
        grid-template-columns: 44rem 1fr;
        grid-template-rows: min-content max-content;
        grid-template-areas: "profile-navigation content";
      }

      @media (max-width: ${tablet}px) {
        padding-top: 4rem;
      }
    }

    &__navigation {
      display: none;

      @media screen and (min-width: ${desktop}px) {
        display: flex;
        grid-area: profile-navigation;
      }
    }

    &__layout {
      flex: 1;
      display: flex;
      padding-top: 2.4rem;
      padding-bottom: 3.2rem;

      @media (max-width: ${tablet}px) {
        padding-top: 2.4rem;
      }
    }

    &__content {
      grid-area: content;
      flex: 1;
      padding: 0 8rem;

      @media (max-width: ${desktop}px) {
        padding: 0 4rem;
      }

      @media (max-width: ${mobile}px) {
        padding: 0;
      }

      .Clickable {
        padding-left: 0;
        padding-top: 0;
      }

      &__title {
        margin-bottom: 2.4rem;
        font-size: 2.4rem;
        font-weight: 700;
        line-height: 3.6rem;
        color: var(--palette-black-s0-l10);
      }

      &__info {
        font-size: 1.6rem;
        color: var(--palette-black-s0-l10);
        padding-bottom: 2.4rem;
        border-bottom: 0.1rem solid var(--palette-gray-s0-l95);
        margin-bottom: 2.4rem;
      }
    }

    &__contact {
      width: 36rem;
      display: flex;
      align-items: center;
      border: 0.1rem solid var(--palette-black-s2-l21);
      border-radius: 1.2rem;
      background-color: var(--palette-gray-s0-l97);
      padding: 1.2rem 1.6rem;
      text-decoration: none;

      & p {
        color: var(--palette-black-s0-l10);
        font-weight: 600;
        font-size: 1.4rem;
        margin-left: 1.6rem;
        width: 75%;
      }

      & span {
        padding-left: 0;
        font-weight: 400;
        line-height: 1.8rem;
        font-size: 1.4rem;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

      @media (max-width: ${tablet}px) {
        font-weight: 400;
        width: unset;
      }

      &:not(:last-child) {
        margin-bottom: 2.4rem;
      }

      span {
        flex: 1;
      }
    }

    &__email-icon {
      padding: 0.4rem;
      background-color: var(--palette-black-h60-s25-l2-a10);
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
    }

    &__whatsapp-icon {
      transform: rotate(90deg);
    }

    &__container {
      background-color: var(--palette-white);
      padding: 2.4rem;
      border-radius: 1.6rem;

      @media (max-width: ${mobile}px) {
        padding: 2.4rem 1.6rem;
      }
    }

    &__footer {
      grid-area: footer;
    }
  }
`;

export default ProfileSupportStyled;
